'use client'

import { useSyncExternalStore } from 'react'

const subscribeToClientMount = () => () => undefined
const getClientMountedSnapshot = () => true
const getServerMountedSnapshot = () => false

/**
 * Returns false during SSR and the hydration render pass, true afterwards.
 * Use to defer browser-only reads (localStorage, matchMedia) that would
 * otherwise make hydrated markup diverge from the server HTML.
 */
export function useClientMounted(): boolean {
  return useSyncExternalStore(
    subscribeToClientMount,
    getClientMountedSnapshot,
    getServerMountedSnapshot
  )
}
